import { request } from "#/utils/request";

interface IGetVendaResumo {
  codigoComissionado: string;
  idPessoa: number;
  idSimulacao: number;
  idContaBancaria: string;
  documento: string;
}

export interface IGetVendaResumoData {
  data: Data;
  errors: any;
}

interface Data {
  nomeProduto: string;
  nomeBem: string;
  prazoRestante: number;
  numeroParcela: number;
  valorPrimeirasParcelas: number;
  valorDemaisParcelas: number;
  percentualTaxaAdm: number;
  percentualTaxaAntecipada: number;
  endereco: string;
  numeroEndereco: string;
  bairro: string;
  complemento: string;
  cep: string;
  cidade: string;
  estado: string;
  telefone: string;
  email: string;
  banco: string;
  tipoConta: string;
  numeroAgencia: string;
  numeroContaCorrente: string;
  percentualReservaTotal: number;
  idFormaRecebimento1: string;
  idFormaRecebimento2: string;
  dataVencimentoProposta: string;
}

export const getVendaResumo = async ({
  codigoComissionado,
  idPessoa,
  idSimulacao,
  idContaBancaria,
  documento,
}: IGetVendaResumo) =>
  (
    await request.post<IGetVendaResumoData>(
      `/vendas/resumo?codigoComissionado=${codigoComissionado}&idPessoa=${idPessoa}&idSimulacao=${idSimulacao}&documento=${documento}`,
      {
        id_forma_recebimento_1: "BB",
        id_forma_recebimento_2: "DB",
        id_conta_bancaria_encerramento: idContaBancaria,
        id_conta_bancaria_debito_1: 0,
        id_conta_bancaria_debito_2: idContaBancaria,
        id_proposito_aquisicao: 9999,
        sn_envio_sms: "N",
        sn_sigilo: "N",
        sn_seguro: "N",
      }
    )
  ).data;
